<template>
  <div
    class="flex flex-col items-center mx-auto mt-[90px] mb-[200px] w-[421px]"
  >
    <div class="text-center">
      <Resource
        :src="getFeUrl('/youyan-platform/png/no-search-data.png')"
        :transform-resource="transformImage"
        class="w-[120px] h-[120px]"
      />
    </div>
    <div class="mt-[16px] text-font-80">
      {{
        $t(
          'wei-jian-suo-dao-nei-rong-nin-ke-yi-chang-shi-sou-suo-yi-xia-guan-jian-ci'
        )
      }}：
    </div>
    <div class="mt-[14px]">
      <Popular
        class="flex-1 justify-center"
        position="empty"
        :list="list"
        @select="selectTag"
      />
    </div>
    <div class="mt-[15px]">
      <a
        class="flex-y-center cursor-pointer gap-[4px] text-14 text-font-60 hover:text-primary"
        @click="emits('refresh')"
      >
        <iconpark-icon name="reset-circle" />{{ $t('huan-yi-huan') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import Popular from '@/features/searchInput/popular.vue'
defineProps({
  list: {
    type: Array,
    default: () => [],
  },
})

const emits = defineEmits(['select', 'refresh'])

const selectTag = (val: string) => {
  emits('select', val)
}
</script>
